// @ts-check
import React, { useState, useEffect } from "react";
import "./App.scss";
import * as funciones from "./appfunciones";
import Router from "./router";
import SplashScreen from "./pages/splachscreen/page";
import { ClientSetting } from "./Appsettings";

export const ContextoGeneral = React.createContext("");
function App() {
  const [AppReady, setAppReady] = useState(false);
  useEffect(() => {
    const InicioApp = document.getElementById("InicioApp");
    if (InicioApp) {
      InicioApp.style.display = "none";
    }
    funciones._iniciar().then(() => {
      setAppReady(true);
    });
  }, []);

  if (!AppReady) {
    return (
      <>
        <style>
          {`:root {
        --primary: #1b6990;
    --primary-foreground: white;
    --secondary: #22252a;
    --tertiary: #cd3618;
      }`}
        </style>
        <SplashScreen message="Iniciando APP" />
      </>
    );
  }
  return (
    <>
      <style>
        {`:root {
        --primary: ${ClientSetting.Theme.primary};
        --primary-foreground: ${ClientSetting.Theme.primaryForeground};
        --secondary: ${ClientSetting.Theme.secondary};
        --tertiary: ${ClientSetting.Theme.tertiary};
        --glassBackground: rgba(255, 255, 255, 0.05);
      }`}
      </style>
      <div className="App">
        <Router />
      </div>
    </>
  );
}

//////eliminar en siguiente update///////////
export default App;
const ErrorConCom = () => {
  return (
    <div className="ConError">
      <div className="contenedor">
        <div className="imagen">
          <img src="/IMG/conexion_lost.png" alt="" />
        </div>
        <div className="texto">Conexion perdida con el servidor</div>
        <div className="exp">
          Verifique la conexion a internet y recargue la app.
        </div>
      </div>
    </div>
  );
};
